import React, { FC } from "react";
import { OrganizationContext } from "./OrganizationContext";
import { useQuery } from "@tanstack/react-query";
import { useOrganizationDao } from "./useOrganizationDao";
import { useCustomerEnvironmentNameOrThrow } from "firefly-shared-ts-customer-environment";

export interface OrganizationProviderProps {
  children: React.ReactNode;
  loadingComponent: React.ReactNode;
}

export const OrganizationProvider: FC<OrganizationProviderProps> = (props) => {
  const customerEnvironment = useCustomerEnvironmentNameOrThrow();
  const organizationDao = useOrganizationDao();
  const result = useQuery({
    queryKey: [
      "OrganizationDao.get",
      customerEnvironment,
      organizationDao.deps,
    ],
    queryFn: async () => organizationDao.get(customerEnvironment),
    placeholderData: (previousData) => previousData,
    enabled: true,
  });

  if (result.data == null) {
    return props.loadingComponent;
  }

  return (
    <OrganizationContext.Provider value={{ organization: result.data }}>
      {props.children}
    </OrganizationContext.Provider>
  );
};
